import { defineStore } from 'pinia'

import type { VoipRoomStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useVoipRoomStore = defineStore('voip-room', {
  state: (): VoipRoomStore => ({
    roomData: null,
    roomLoading: false,
    bookingVoip: null,
  }),
  actions,
  getters,
})
